import { useMemo } from "react"
import type { Lot } from "@stockline/shared/types/inventory/lot"
import { LOT_TABLE } from "../../../lib/offline/resources/inventory/lot/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UseLotsFilter {
  status?: string
  supplierId?: string
  includeDeleted?: boolean
}

export function useLots(filter?: UseLotsFilter): Lot[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<Lot>(LOT_TABLE, {
    ...(filter?.status !== undefined ? { status: filter.status } : {}),
    ...(filter?.supplierId ? { supplierId: filter.supplierId } : {}),
    orderBy: "lotNumber",
  })
  const includeDeleted = filter?.includeDeleted
  return useMemo(
    () => (includeDeleted ? rows : rows.filter((r) => !r.deletedAt)),
    [rows, includeDeleted]
  )
}
